import { ConfigVersion } from './ConfigVersion';

export class ConfigVersionDateRange {
  startDate!:Date | null;

  endDate!:Date | null;

  constructor(startDate: string|null, endDate: string|null) {
    this.startDate = startDate === null ? null : new Date(startDate);
    this.endDate = endDate === null ? null : new Date(endDate);
  }

  // Implementation assumes allVersions array is ordered descending by design start date
  public static ofVersion(currentVersion: ConfigVersion, allVersions: ConfigVersion[]): ConfigVersionDateRange {
    const currentVersionId = currentVersion.id;
    const currentStartDateStr = currentVersion.startDate;
    let nextVersionStartDateStr: null | string = null;
    for (let i = 0; i < allVersions.length; i++) {
      if (allVersions[i].id === currentVersionId) {
        break;
      }
      if (i === allVersions.length - 1) {
        nextVersionStartDateStr = null;
      } else {
        nextVersionStartDateStr = allVersions[i].startDate;
      }
    }

    let currentEndDateStr: string | null = null;
    if (nextVersionStartDateStr) {
      const nextStartDate = new Date(nextVersionStartDateStr!);
      nextStartDate.setDate(nextStartDate.getDate() - 1);
      currentEndDateStr = nextStartDate.toISOString().substring(0, 10);
    }

    return new ConfigVersionDateRange(currentStartDateStr, currentEndDateStr);
  }

  isInConfigRange(date: string): boolean {
    const dateToCompare: Date = new Date(date);
    if (this.startDate && dateToCompare < this.startDate) {
      return false;
    }
    if (this.endDate && dateToCompare > this.endDate) {
      return false;
    }
    return true;
  }
}

export default ConfigVersionDateRange;
